import { AiOutlinePlus } from 'react-icons/ai';
import styled from 'styled-components';

export const AreaCard = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10%;
  min-height: 60vh;
  width: auto;
`;

export const Content = styled.div`
  display: grid;

  grid-template-columns: repeat(5, 135px);
  gap: 2.2rem;

  @media (max-width: 1500px) {
    grid-template-columns: repeat(3, 135px);
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 100px);
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;

export const NewCardButton = styled.div`
  height: 18.4rem;
  width: 13.5rem;
  background: ${({ theme }) => theme.colors.base[250]};
  border-radius: 16px;
  padding: 1.1rem 1.3rem;
  box-shadow: 1px 1px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3.138rem;

  cursor: pointer;

  :hover {
    transform: scale(0.99);
    box-shadow: none;
  }
`;

export const PlusIcon = styled(AiOutlinePlus).attrs({
  size: '26',
  color: '#539ADA',
})``;

export const ButtonTitle = styled.strong`
  font-family: ${({ theme }) => theme.fonts.Poppins};
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.base[400]};
`;

export const WrapperNavigator = styled.div`
  display: flex;
  width: 100%;
  margin: 5rem 0 3.2rem 0;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
`;

export const TotalItems = styled.div`
  color: ${({ theme }) => theme.colors.base[500]};
  font-size: 1.8rem;
  font-weight: 600;
`;
